import React from 'react';
import { Typography, Tag, Button } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { Banner } from '../../types/banner';
import { getBannerStatusData } from '../../utils';
import { useTemplateInfo } from '../../hooks/banners/use-template-utils';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';

const { Title } = Typography;

interface AssetModalHeaderProps {
  banner: Banner;
  onClose: () => void;
}

export const AssetModalHeader: React.FC<AssetModalHeaderProps> = ({ banner, onClose }) => {
  const { fontSize, spacing, screens } = useResponsiveSizes();
  const { title } = useTemplateInfo(banner?.bannerType === '' ? undefined : banner?.bannerType);

  return (
    <div style={{ position: 'relative' }}>
      {/* Botón de cerrar */}
      <Button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: spacing.sm,
          right: spacing.sm,
          background: 'transparent',
          border: 'none',
          borderRadius: '50%',
          width: screens.xs ? '32px' : '36px',
          height: screens.xs ? '32px' : '36px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 20,
          color: '#64748b',
          transition: 'all 0.2s',
          zIndex: 10
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.02)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <CloseCircleFilled />
      </Button>

      {/* Header content */}
      <div
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          padding: `${spacing.md}px ${spacing.lg}px`,
          borderBottom: '1px solid #e2e8f0'
        }}
      >
        <div style={{ display: 'flex', gap: spacing.md }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Title
              style={{
                margin: '0 0 4px 0',
                color: '#0f172a',
                fontWeight: 'bold',
                lineHeight: 1.3,
                marginBottom: spacing.sm,
                fontSize: fontSize.xxl
              }}
            >
              {banner?.title || 'Asset'}
            </Title>

            <div style={{ display: 'flex', gap: spacing.sm, flexWrap: 'wrap' }}>
              {banner.bannerType !== '' && title && (
                <Tag
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: 12,
                    fontSize: fontSize.sm,
                    padding: `${spacing.sm}px ${spacing.sm}px`,
                    fontWeight: 800,
                    height: 20,
                    lineHeight: '20px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    textTransform: 'uppercase'
                  }}
                >
                  {title}
                </Tag>
              )}

              {banner?.status && (
                <Tag
                  style={{
                    ...getBannerStatusData(banner),
                    border: 'none',
                    borderRadius: 12,
                    fontSize: fontSize.sm,
                    padding: `${spacing.sm}px ${spacing.sm}px`,
                    fontWeight: 800,
                    height: 20,
                    lineHeight: '20px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {getBannerStatusData(banner).label.toUpperCase()}
                </Tag>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
